import React from "react";
import { Box, Typography } from "@mui/material";

import { CHECKOUT_COPY } from "../constants";

// Transition shown while the ScratchPay checkout url resolves. Rendered on
// the public route too (no app shell), hence the min-height fallback.
export const ScratchRedirectScreen = () => (
  <Box className="flex h-full min-h-[70vh] w-full flex-col items-center justify-center px-4">
    {/* TODO(SGPD-547): design shows a static dog illustration
        (Figma 35703:52739) — confirm the asset with the designer. */}
    <img
      src="/assets/icons/Foxhound_Loading.gif"
      className="w-96 max-w-full"
      alt="Loading"
    />
    <Typography variant="h4" sx={{ fontWeight: 600, textAlign: "center", mt: 2 }}>
      {CHECKOUT_COPY.TRANSITION_TITLE}
    </Typography>
    <Typography variant="body1" sx={{ textAlign: "center", mt: 1, maxWidth: "36rem" }}>
      {CHECKOUT_COPY.TRANSITION_SUBTITLE}
    </Typography>
  </Box>
);

export default ScratchRedirectScreen;
